import React from 'react';
import { Layout } from 'antd';

import DateContextProvider from '../Components/Context/DateContext';
import DrawerContextProvider from '../Components/Context/DrawerContext';
import FeedContextProvider from '../Components/Context/FeedContext';
import AddArticleFormDrawer from '../Components/Drawer/AddArticleForm';
import NotifContextProvider from '../Components/Context/NotifContext';
import ThemeContextProvider from '../Components/Context/ThemeContext';
import Feed from '../Components/Feed/Feed';
import ProfileContextProvider from '../Components/Context/ProfileContext';
import ProfileDrawer from '../Components/Drawer/ProfileView';
import PaymentContextProvider from '../Components/Context/PaymentContext';

export default function Homepage(props) {
  return (
    <div>
      <ThemeContextProvider>
        <NotifContextProvider>
          <DrawerContextProvider>
            <ProfileContextProvider>
              <FeedContextProvider>
                <PaymentContextProvider>
                  <Layout>
                    <DateContextProvider>
                      <AddArticleFormDrawer />
                      <ProfileDrawer />
                      <Feed />
                    </DateContextProvider>
                  </Layout>
                </PaymentContextProvider>
              </FeedContextProvider>
            </ProfileContextProvider>
          </DrawerContextProvider>
        </NotifContextProvider>
      </ThemeContextProvider>
    </div>
  );
}
